import type { FileType } from "./types";

export const WEB_PAGES_FLAG = "ampWebPagesEnabled";

export function fileTypeAccess({
  amp,
  ads,
  lcm,
  webPages,
}: {
  amp: boolean;
  ads: boolean;
  lcm: boolean;
  webPages: boolean;
}): Record<FileType, boolean> {
  return {
    ad: amp && ads,
    email: amp && lcm,
    sms: amp && lcm,
    push: amp && lcm,
    html: amp && webPages,
    doc: amp,
    upload: amp,
    slides: amp,
    canvas: amp,
  };
}
